<template>
  <div>
    <div v-if="isMobile">
      <app-history v-for="index in history.length" :key="index" :index="index - 1" :item="history[index - 1]"
        :selectedItem="selectedItem" @clicked="onClickItem" @removeRequest="removeRequest"
        @callDownload="callDownloadFromCard">
      </app-history>
    </div>
    <div v-else>
      <v-data-table :items="history" item-key="Fserial" :headers="historyHeaders" class="elevation-1 rounded"
        :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText" show-expand>
        <template v-slot:[`item.Removable`]="{ item }">
          <v-btn class="grid" v-if="item.Removeable" color="red white--text" rounded
            @click="removeRequest(item.Fserial)">
            حذف درخواست
          </v-btn>
          <v-btn class="grid" v-else-if="item.State == 1" color="red white--text" rounded
            @click="callDownload(item.Fserial)">
            دانلود گواهی تلبس
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <br />
            <b>نظر واحد حراست: </b>{{ item.TahghighatState }}.
            <span v-html="item.TahghighatComment"></span>
            <br />
            <template v-if="item.ShowMessage">
              <br />
              <b>شرکت در کارگاه تلبس:</b>
              <br />
              <br />
              جهت شركت در كارگاه تلبس در مدرسه تبليغ، به آدرس زير مراجعه فرماييد:
              <br />
              <br />
              <a href="https://tabliqkh.lms2.hozehkh.com/products/?categories=1731" target="_blank">
                <img :src="require(`../../assets/talabbos_icon.png`)" style="width: 24px" alt="ایتا" />
                سامانه مجازي مبلغان، مدرسه تبليغ
              </a>

              <br />
              <br />
              در صورت هرگونه سوال با شماره 05132008690 تماس حاصل
              فرماييد.
              <br />
              <br />
              با تشکر

              <br />
            </template>
            <br />
            <b>شرکت در کارگاه: </b>{{ item.TabliqState }}.
            <span v-html="item.TabliqComment"></span>
            <br />
            <br />
            <b>نظر مدير محترم مدرسه يا استاد سطح دو:</b>{{ item.TabliqState2 }}.
            <span v-html="item.TabliqComment2"></span>
            <br />
            <br />
          </td>
        </template>
      </v-data-table>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import History from "./Item";
import Dialog from "@/components/Dialog";
import {
  getTalabbosHistory,
  removeTalabbosRequest,
  download,
} from "@/api/talabbos";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appHistory: History,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedItem: -1,
      history: [],
      historyHeaders: [
        {
          text: "وضعیت",
          value: "StrState",
          width: "15%",
        },
        {
          text: "شناسه درخواست",
          value: "Fserial",
          width: "20%",
        },

        {
          text: "تاریخ درخواست",
          value: "DDate",
          width: "15%",
        },

        {
          text: "",
          value: "Removable",
          width: "15%",
          sortable: false,
        },

        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
    };
  },
  created() {
    this.getTalabbosHistory();
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    getTalabbosHistory() {
      this.$store.commit("SET_TABLE_TEXT", true);
      getTalabbosHistory()
        .then((response) => {
          const data = response.data;
          this.history = data;

          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    onClickItem(index) {
      if (this.selectedItem != index) {
        this.selectedItem = index;
      } else {
        this.selectedItem = -1;
      }
    },

    /**
     * show confirm dialog
     */
    removeRequest(index) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", index);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این درخواست هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        removeTalabbosRequest(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.getTalabbosHistory();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    callDownloadFromCard(data) {
      this.callDownload(data);
    },
    callDownload(index) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      download(index)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
<style scoped>
.grid {
  margin: 10px 0;
}
</style>
